import {isMobile, isTablet} from 'react-device-detect';

const useIsMobile = (): boolean => {
  return isMobile && !isTablet;
};

export default useIsMobile;
